import { VehicleWithChauffeurResponse } from '@/types/benefits/VehicleWithChauffeurResponse';
import { CURRENCIES } from '../../../../../shared/CountriesData';
import { SupportedLocale } from '@/types/supported-locale.type';
import { LOCALES } from '@/i18n/config';
import { numberIfNotUndefined } from '../../prices/numberIfNotUndefined';

const initializeVehicleWithChauffeurTranslations = (
  vehicleWithChauffeur: VehicleWithChauffeurResponse,
) => {
  const translations: Record<
    SupportedLocale,
    {
      model?: string;
      shortDescription?: string;
      longDescription?: string;
      benefit?: { name?: string };
    }
  > = {} as Record<
    SupportedLocale,
    {
      model?: string;
      shortDescription?: string;
      longDescription?: string;
      benefit?: { name?: string };
    }
  >;

  for (const locale of LOCALES) {
    translations[locale] = {
      model:
        vehicleWithChauffeur.translations?.[locale]?.model ??
        vehicleWithChauffeur.model ??
        '',
      shortDescription:
        vehicleWithChauffeur.translations?.[locale]?.shortDescription ??
        vehicleWithChauffeur.shortDescription ??
        '',
      longDescription:
        vehicleWithChauffeur.translations?.[locale]?.longDescription ??
        vehicleWithChauffeur.longDescription ??
        '',
      benefit: {
        name:
          vehicleWithChauffeur.translations?.[locale]?.benefit?.name ??
          vehicleWithChauffeur.benefit.name ??
          '',
      },
    };
  }

  return translations;
};

export const loadVehicleWithChauffeurDefaultValues = (
  vehicleWithChauffeur: VehicleWithChauffeurResponse,
) => ({
  translations:
    initializeVehicleWithChauffeurTranslations(vehicleWithChauffeur),
  name: vehicleWithChauffeur.benefit.name,
  supplier: {
    label: vehicleWithChauffeur.benefit.supplier.name,
    value: vehicleWithChauffeur.benefit.supplier.id,
  },
  currency: vehicleWithChauffeur.benefit.currency
    ? {
        value: vehicleWithChauffeur.benefit.currency,
        label: CURRENCIES.find(
          (currency) =>
            currency.value === vehicleWithChauffeur.benefit.currency,
        )?.label,
      }
    : undefined,
  country: vehicleWithChauffeur.benefit.country
    ? {
        label: vehicleWithChauffeur.benefit.country,
        value: vehicleWithChauffeur.benefit.country,
      }
    : undefined,
  marginRate: numberIfNotUndefined(vehicleWithChauffeur.benefit.marginRate),
  model: vehicleWithChauffeur.model ?? undefined,
  shortDescription: vehicleWithChauffeur.shortDescription ?? undefined,
  longDescription: vehicleWithChauffeur.longDescription ?? undefined,
  images: vehicleWithChauffeur.images ?? [],
  maxCapacity: vehicleWithChauffeur.maxCapacity
    ? Number(vehicleWithChauffeur.maxCapacity)
    : undefined,
  tarifs:
    vehicleWithChauffeur.benefit.Pricing.length > 0
      ? vehicleWithChauffeur.benefit.Pricing.map((tarif) => ({
          name: tarif.name ?? undefined,
          periods: tarif.periods.map((period) => ({
            startDate: period.startDate
              ? new Date(period.startDate)
              : undefined,
            endDate: period.endDate ? new Date(period.endDate) : undefined,
            applicationDays: period.applicationDays,
          })),
          pricePartitions: tarif.pricePartitions.map((partition) => ({
            price: numberIfNotUndefined(partition.price),
            from: partition.from ? Number(partition.from) : undefined,
            to: partition.to ? Number(partition.to) : undefined,
          })),
        }))
      : [
          {
            name: undefined,
            periods: [
              {
                startDate: undefined,
                endDate: undefined,
                applicationDays: [],
              },
            ],
            pricePartitions: [
              {
                price: undefined,
                from: 1,
                to: 1,
              },
            ],
          },
        ],
});
